import React, { useState, useEffect } from 'react';
import VerticalBarChart from '../components/VerticalBarChart';
import secureRemainingForecastBusinessUnits from './secure_remaining_forecast_business_units.service';
const SecureRamainingForecastQE = _ref => {
  let {
    filteredBusinessUnits,
    selectedYears,
    companyId,
    selectedSubsidiaryCompanyIds
  } = _ref;
  const businessUnitData = [];
  const qeGroups = [];
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const businessUnitsParam = filteredBusinessUnits.map(bu => bu.business_unit_id).join(',');
        const yearsParam = selectedYears.join(',');
        const subsidiaryCompanyIdsParam = selectedSubsidiaryCompanyIds.join(',');
        const data = await secureRemainingForecastBusinessUnits.all(companyId, businessUnitsParam, yearsParam, subsidiaryCompanyIdsParam);
        const transformedData = Object.entries(data).map(_ref2 => {
          let [label, value] = _ref2;
          return {
            label,
            value: parseFloat(value)
          };
        });
        setChartData(transformedData);
      } catch (error) {
        console.error('Error fetching Secure QE forecast by subsidiary company:', error);
      }
    };
    fetchData();
  }, [companyId, filteredBusinessUnits, selectedYears, selectedSubsidiaryCompanyIds]);

  // filteredBusinessUnits.forEach(bu => {
  //   const qeYears = Object.keys(bu.qe_by_year)
  //   const currentYears = qeYears.filter(year => selectedYears.includes(Number(year)))

  //   currentYears.length > 0 && qeGroups.push({
  //     title: bu.business_unit.length > 15 ? bu.business_unit.substring(0, 15) + '...' : bu.business_unit,
  //     cols: currentYears.length
  //   })
  //   const qeDataByYear = currentYears.map(year => {
  //     return {
  //       label: year,
  //       value: Math.round(bu.qe_by_year[year])
  //     }
  //   })
  //   businessUnitData.push(...qeDataByYear)
  // })

  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-card dashboard-card-group-chart"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center dashboard-regular-card-title"
  }, "Secure QE (\xA3)"), /*#__PURE__*/React.createElement(VerticalBarChart, {
    data: chartData,
    dataName: "Secure QE (\xA3)",
    showLables: true,
    showLegend: false,
    colors: ['#00afef', '#0078b9', '#00b08b']
  }));
};
export default SecureRamainingForecastQE;